import { AxiosError } from 'axios'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { User } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface ClientUserProps {
  email: string
  first_name: string
  last_name: string
}

const clientUserSchema = yup.object().shape({
  email: yup.string().required().label('E-Mail'),
  first_name: yup.string().required().label('First Name'),
  last_name: yup.string().required().label('Last Name'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  clientGuid: string
  user?: User
}

export const ClientUserDialog = (props: Props) => {
  const { open, handleClose, onSave, update, clientGuid, user } = props
  const classes = useStyles()

  const onSubmit = (data: ClientUserProps) => {
    let func = (data: ClientUserProps) => skuit.sc.clients.users.create(clientGuid, data)
    let action = 'creat'
    if (update) {
      func = (data: ClientUserProps) => skuit.sc.clients.users.patch(clientGuid, user?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newClientUser: User) => {
        handleClose()
        onSave?.()
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed ClientUser: ${newClientUser.fullName}`}
            newObject={newClientUser}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'ClientUser')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, Field, data: formData } = useForm(clientUserSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>{update ? 'Update' : 'Create'} Client User</DialogTitle>
        <DialogContent>
          <Field
            name="email"
            defaultValue={user?.email}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                disabled={update}
                name={name}
                label="E-Mail"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
          <Field
            name="first_name"
            defaultValue={user?.firstName}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="First Name"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
          <Field
            name="last_name"
            defaultValue={user?.lastName}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Last Name"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
